import type { PropsWithChildren } from "react";
import { BrowseWordsPageContext } from "#browse-words-page-context";
import { useBrowseWordsPageContextValue } from "#browse-words-page-context-value";

export function BrowseWordsPageContextProvider({ children }: PropsWithChildren) {
  const value = useBrowseWordsPageContextValue();
  return (
    <BrowseWordsPageContext.Provider value={value}>{children}</BrowseWordsPageContext.Provider>
  );
}
